import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function createTreatmentContext() {
  return /*#__PURE__*/createContext(undefined);
}
function makeTreatmentProvider(TreatmentContext, client) {
  return function ({
    children
  }) {
    const [isLoading, setIsLoading] = useState(true);
    const [treatments, setTreatments] = useState(undefined);
    useEffect(() => {
      client.resolve(result => {
        setTreatments(result);
        setIsLoading(false);
      });
    }, []);
    const context = useMemo(() => ({
      treatments,
      client,
      isLoading
    }), [isLoading, treatments]);
    return /*#__PURE__*/_jsx(TreatmentContext.Provider, {
      value: context,
      children: children
    });
  };
}
export function makeUseTreatment(TreatmentContext) {
  return function (treatmentKey, shouldLogExposure = false) {
    const context = useContext(TreatmentContext);
    if (!context) {
      throw new Error('Wrap the root of your library or app with a TreatmentProvider');
    }
    const {
      treatments,
      client,
      isLoading
    } = context;
    useEffect(() => {
      if (shouldLogExposure) {
        client.logExposure(treatmentKey);
      }
    }, [client, shouldLogExposure, treatmentKey]);
    const parameters = treatments && treatments[treatmentKey] && treatments[treatmentKey].parameters;
    return {
      isLoading,
      parameters
    };
  };
}
export function makeLaboratoryHooks(client) {
  const TreatmentContext = createTreatmentContext();
  const TreatmentProvider = makeTreatmentProvider(TreatmentContext, client);
  const useTreatment = makeUseTreatment(TreatmentContext);
  return {
    TreatmentContext,
    TreatmentProvider,
    useTreatment
  };
}